import React, { useEffect, useState } from 'react';
import { Box, Table, Tbody, Td, Text, Th, Thead, Tr, VStack } from '@chakra-ui/react';
import { ObjectSeasonPrice } from '../../types/ObjectTypes';

import styled from '@emotion/styled';

export const TablePricingWrapper = styled.div`
  td {
    padding: 10px 0 10px 0;
  }

  @media (max-width: 767px) {
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border-bottom: 2px solid var(--chakra-colors-gray-500);
    }

    td {
      border: none;
      border-bottom: 1px solid #eee;
      position: relative;
      padding: 10px 15px;
      padding-left: 50%;
      text-align: unset !important;
    }

    td:before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 8px;
      width: 45%;
      white-space: nowrap;
    }

    td:nth-of-type(1):before {
      content: 'SAISON';
    }

    td:nth-of-type(2):before {
      content: 'ZEITRAUM';
    }

    td:nth-of-type(3):before {
      content: 'MIN. ÜN';
    }

    td:nth-of-type(4):before {
      content: 'PREIS/\ÜBERNACHTUNG';
      white-space: pre-wrap;
    }
  }
`;

export interface PriceRow {
  Title: string;
  from: string;
  to: string;
  numberOfDays: number;
  maxPersons: number;
  totalPrice: string;
}

export interface ObjectDetailsPricingTableProps {
  seasonsPrice: Array<ObjectSeasonPrice>;
}

export const ObjectSeasosPriceTable = (props: ObjectDetailsPricingTableProps): JSX.Element => {
  const { seasonsPrice } = props;

  const [formattedPricesData, setFormattedPricesData] = useState<Array<PriceRow>>([]);

  useEffect(() => {
    const formattedPrices = seasonsPrice.map(price => {
      return {
        Title: price.Title,
        from: new Intl.DateTimeFormat('de-De').format(new Date(price.from)),
        to: new Intl.DateTimeFormat('de-De').format(new Date(price.to)),
        numberOfDays: price.minimumLength,
        maxPersons: price.maxPersons,
        totalPrice: new Intl.NumberFormat('de-De', {
          style: 'currency',
          currency: 'EUR',
        }).format(price.totalPrice),
      };
    });

    setFormattedPricesData(formattedPrices);
  }, [seasonsPrice]);

  return (
    <Box
      p={4}
      borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
      borderWidth={1}
      borderColor={'gray.300'}
      backgroundColor={'white'}
      w={'100%'}
      h={{ base: 'calc(100% - 56px)', md: 'auto' }}
      overflow={'auto'}>
      <VStack gridGap={4}>
        <Text w={'100%'} textAlign={'left'} fontSize={'xl'} textStyle={'category.primary'} pl={0}>
          Übernachtungspreise
        </Text>
        <Box w={'100%'}>
          <TablePricingWrapper>
            <Table size={'lg'}>
              <Thead>
                <Tr>
                  <Th pl={0}>Saison</Th>
                  <Th isNumeric={false}>Zeitraum</Th>
                  <Th isNumeric={false}>min. ÜN</Th>
                  <Th pr={0} isNumeric={true}>
                    Preis/Übernachtung
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {formattedPricesData.map((price, idx) => {
                  return (
                    <Tr key={idx}>
                      <Td pl={0} color={'gray.800'} isNumeric={false}>
                        {price.Title}
                      </Td>
                      <Td color={'gray.800'} isNumeric={false}>
                        {price.from} - {price.to}
                      </Td>
                      <Td color={'gray.800'} isNumeric={false}>
                        {price.numberOfDays}
                      </Td>
                      <Td pr={0} color={'gray.800'} isNumeric={true}>
                        {price.totalPrice} bei {price.maxPersons} Pers.
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TablePricingWrapper>
        </Box>
      </VStack>
    </Box>
  );
};
